









import { Component, Vue } from 'vue-property-decorator'
import { isTourist, goToLogin } from '@/utils/util'
@Component({
  name: 'companyApprove'
})
export default class companyApprove extends Vue {
  isTourist = isTourist
  goToLogin = goToLogin

  handleClick () {
    if (isTourist()) {
      goToLogin()
      return false
    }
  }

  toPage() {
    if (isTourist()) {
      goToLogin()
      return false
    }
    this.$router.push('/companyInfoForm?formPage=h5')
  }
}
